interface GallerySlot {
  caption: string;
  span: string;
  image: string;
}

const gallerySlots: GallerySlot[] = [
  {
    caption: 'Naša jedilnica',
    span: 'col-span-2 row-span-2',
    image: 'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/29f8a11afc46af1a93824a77eee0ece3.png',
  },
  {
    caption: 'Pogrnjena miza',
    span: 'col-span-1 row-span-1',
    image: 'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/e101ebbf386c71d7396975670c131308.png',
  },
  {
    caption: 'Domača penina',
    span: 'col-span-1 row-span-1',
    image: 'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/97dc4ddb767ba32989ad9fb71ff7cba6.png',
  },
];

export default function GallerySection() {
  return (
    <section id="galerija" className="relative bg-background-100 py-16 md:py-24 lg:py-32">
      <div className="w-full px-5 md:px-10 lg:px-14">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <p className="font-label text-xs tracking-extra-wide text-accent-600 font-medium uppercase mb-3">
              GALERIJA
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-light text-foreground-950 mb-3">
              Ujeti trenutki
            </h2>
            <p className="font-body text-sm md:text-base text-foreground-600">
              Gostilna Marta skozi objektiv.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4 auto-rows-[170px] md:auto-rows-[210px] lg:auto-rows-[230px]">
            {gallerySlots.map((slot, idx) => (
              <div
                key={idx}
                className={`gallery-item group relative overflow-hidden rounded-lg ${slot.span}`}
              >
                <img
                  src={slot.image}
                  alt={slot.caption}
                  title={`${slot.caption} – Gostilna Marta`}
                  className="w-full h-full object-cover object-top group-hover:opacity-75 transition-opacity"
                />
                <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4 bg-gradient-to-t from-black/55 to-transparent pointer-events-none">
                  <p className="font-label text-[10px] md:text-xs text-white/90 tracking-wide">
                    {slot.caption}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}